import React from 'react';
import axios from 'axios';

import * as Globals from './../Globals';


export default class TestResult extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            name: ""
        };
    }

    componentDidMount() {
        let cookie = this.props.LogoutOnCookieNotSet();
        axios.get(Globals.BASE_PATH + 'api/users/' + this.props.userID,
            {
                headers: {
                    'Accept': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${cookie}`
                }
            }).then((response) => {
            this.setState({
                name: `${response.data.data['personal-data'].title || ""} ${response.data.data['personal-data'].firstName} ${response.data.data['personal-data'].lastName}`
            });
        }).catch((error) => {
            this.props.CheckAuthError(error);
        });
    }

    getSignBlock() {
        if (!this.props.is_unlocked) {
            return (
                <td>
                    <button className="btn btn-success btn-sm center-block" type="button"
                            onClick={() => this.props.sendViewProtocol(this.props.id, this.state.name, this.props.mark)}>Kontrollieren
                    </button>
                </td>
            );
        }
        return (
            <td style={{"color": "#777777"}} className="text-center">Kontrolliert</td>
        );
    }

    render() {
        return (
            <tr>
                <td>{this.state.name}</td>
                <td>{this.props.mark}</td>
                {this.getSignBlock()}
            </tr>
        );
    }

}



// WEBPACK FOOTER //
// ./src/admin/TestResult.js